<template>
   <div class="price-information-summary-wrapper hotel-order-detail-inner-section">
      <div class="price-information-summary-inner">
         <div class="price-information-table-wrapper">
            <div class="price-information-table-inner">
               <div class="price-information-table-header">
                  <div class="table-header-fixed-item">
                     <span>{{ $t("orderDetail_lblRoomType") }}</span>
                  </div>
                  <div class="table-header-list">
                     <span>{{ $t("orderDetail_lblAccommodationDate") }}</span>
                     <span>{{ $t("orderDetail_lblAgencyPrice") }}</span>
                     <span>{{ $t("orderDetail_lblAgencyCommission") }}</span>
                     <span>{{ $t("orderDetail_lblTotalPrice") }}</span>
                  </div>
                  <div class="table-header-fixed-item" v-if="size > 4"></div>
               </div>
               <div class="price-information-table-content">
                  <div class="price-information-room-item" v-for="(priceItem, index) in prices" :key="index">
                     <div class="table-content-fixed-item">
                        <span class="masked">{{ priceItem.channelRoomName }}</span>
                     </div>
                     <div class="table-content-list">
                        <ul class="price-information-list default-list" v-if="priceItem.roomPrices.length <= 4">
                           <li class="price-information-list-item" v-for="(roomPrice, index) in priceItem.roomPrices" :key="index">
                              <span class="masked" :data-label="$t('orderDetail_lblAccommodationDate')">{{ roomPrice.accommodationDate | fullDateFormat }}</span>
                              <span class="masked" :data-label="$t('orderDetail_lblAgencyPrice')">{{ roomPrice.baseAmount | price(roomPrice.currency) }}</span>
                              <span class="masked" :data-label="$t('orderDetail_lblAgencyCommission')">{{ roomPrice.agencyCommission | price(roomPrice.currency) }}</span>
                              <span class="total-price masked" :data-label="$t('orderDetail_lblTotalPrice')">{{ roomPrice.totalAmount | price(roomPrice.currency) }}</span>
                           </li>
                        </ul>
                        <ul class="price-information-list default-list" v-else>
                           <li class="price-information-list-item first-item">
                              <span class="masked" :data-label="$t('orderDetail_lblAccommodationDate')">{{ priceItem.roomPrices[0].accommodationDate | fullDateFormat }}</span>
                              <span class="masked" :data-label="$t('orderDetail_lblAgencyPrice')">{{ priceItem.roomPrices[0].baseAmount | price(priceItem.roomPrices[0].currency) }}</span>
                              <span class="masked" :data-label="$t('orderDetail_lblAgencyCommission')">{{ priceItem.roomPrices[0].agencyCommission | price(priceItem.roomPrices[0].currency) }}</span>
                              <span class="total-price masked" :data-label="$t('orderDetail_lblTotalPrice')">{{ priceItem.roomPrices[0].totalAmount | price(priceItem.roomPrices[0].currency) }}</span>
                           </li>
                           <div class="price-information-detail-list" :class="isDetailListActive ? 'active' : ''">
                              <template v-for="(roomPrice, index) in priceItem.roomPrices">
                                 <li v-if="index != 0 && index != priceItem.roomPrices.length - 1" :key="index" class="price-information-list-item">
                                    <span class="masked" :data-label="$t('orderDetail_lblAccommodationDate')">{{ roomPrice.accommodationDate | fullDateFormat }}</span>
                                    <span class="masked" :data-label="$t('orderDetail_lblAgencyPrice')">{{ roomPrice.baseAmount | price(roomPrice.currency) }}</span>
                                    <span class="masked" :data-label="$t('orderDetail_lblAgencyCommission')">{{ roomPrice.agencyCommission | price(roomPrice.currency) }}</span>
                                    <span class="total-price masked" :data-label="$t('orderDetail_lblTotalPrice')">{{ roomPrice.totalAmount | price(roomPrice.currency) }}</span>
                                 </li>
                              </template>
                           </div>
                           <li class="price-information-list-item last-item">
                              <span class="masked" :data-label="$t('orderDetail_lblAccommodationDate')">{{ priceItem.roomPrices[priceItem.roomPrices.length - 1].accommodationDate | fullDateFormat }}</span>
                              <span class="masked" :data-label="$t('orderDetail_lblAgencyPrice')">{{ priceItem.roomPrices[priceItem.roomPrices.length - 1].baseAmount | price(priceItem.roomPrices[priceItem.roomPrices.length - 1].currency) }}</span>
                              <span class="masked" :data-label="$t('orderDetail_lblAgencyCommission')">{{
                                 priceItem.roomPrices[priceItem.roomPrices.length - 1].agencyCommission | price(priceItem.roomPrices[priceItem.roomPrices.length - 1].currency)
                              }}</span>
                              <span class="total-price masked" :data-label="$t('orderDetail_lblTotalPrice')">{{
                                 priceItem.roomPrices[priceItem.roomPrices.length - 1].totalAmount | price(priceItem.roomPrices[priceItem.roomPrices.length - 1].currency)
                              }}</span>
                           </li>
                        </ul>
                     </div>
                     <div class="table-content-fixed-item" v-if="priceItem.roomPrices.length >= 4" @click="triggerDetailList">
                        <i class="gts-icon icon-arrow-rounded-up" v-if="isDetailListActive"></i>
                        <i class="gts-icon icon-arrow-rounded-down" v-else></i>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </div>
</template>

<script>
export default {
   name: "PriceInformationSummary",
   props: {
      priceList: { type: Array },
   },
   data() {
      return {
         prices: [],
         size: 7,
         isDetailListActive: false,
      };
   },
   created() {
      const self = this;

      self.prices = this.priceList;
   },
   methods: {
      triggerDetailList() {
         const self = this;
         self.isDetailListActive = !self.isDetailListActive;
      },
   },
   watch: {
      priceList: {
         handler: function (newPriceList) {
            const self = this;
            self.prices = newPriceList;
         },
         deep: true,
      },
   },
};
</script>

<style lang="scss" scoped>
.price-information-summary-wrapper {
   .price-information-summary-inner {
      .price-information-table-wrapper {
         .price-information-table-inner {
            display: block;
            border: 1px solid var(--gray-300);
            border-radius: 10px;
            overflow: hidden;
            .price-information-table-header {
               display: flex;
               justify-content: flex-start;
               align-items: center;
               padding: 16px 42px;
               background-color: var(--gray-200);
               border-bottom: 1px solid var(--gray-300);

               span {
                  font-size: 14px;
                  color: var(--gray-700);
               }

               .table-header-fixed-item {
                  width: 15%;
                  max-width: 15%;
                  margin-right: 24px;

                  &:last-child {
                     width: 5%;
                     max-width: 5%;
                     margin-right: 0;
                  }
               }
               .table-header-list {
                  display: grid;
                  grid-template-columns: repeat(4, 1fr);
                  width: 85%;
                  padding: 0 32px;

                  & > span {
                     text-align: right;
                     &:first-child {
                        text-align: left;
                     }
                  }
               }
            }
            .price-information-table-content {
               .price-information-room-item {
                  display: flex;
                  justify-content: flex-start;
                  align-items: stretch;
                  padding: 16px 42px;
                  background-color: var(--container-bg);
                  border-bottom: 1px solid var(--gray-300);

                  &:last-child {
                     border-bottom: none;
                  }
                  .table-content-fixed-item {
                     width: 15%;
                     max-width: 15%;
                     margin-right: 24px;

                     &:last-child {
                        width: 5%;
                        max-width: 5%;
                        display: flex;
                        align-items: center;
                        justify-content: center;
                        border-right: none;
                        margin-right: 0;
                        cursor: pointer;
                     }

                     & > span {
                        display: inline-flex;
                        justify-content: flex-start;
                        align-items: center;
                        width: 100%;
                        height: 100%;
                        font-weight: 700;
                     }
                  }
                  .table-content-list {
                     width: 78%;
                  }

                  .price-information-list.default-list {
                     .price-information-list-item {
                        display: grid;
                        grid-template-columns: 1.25fr 1fr 1.25fr 1.6fr;
                        border-radius: 20px;
                        margin-bottom: 8px;
                        padding: 10px 32px;

                        &:last-child {
                           margin-bottom: 0;
                        }

                        span {
                           text-align: right;
                           font-weight: 500;

                           &:first-child {
                              text-align: left;
                              font-weight: 500;
                           }
                        }
                        span.total-price {
                           font-weight: 800;
                        }
                     }

                     .price-information-detail-list {
                        max-height: 0;
                        overflow: hidden;
                        transition: max-height 0.5s ease-out;

                        &.active {
                           max-height: 100vh;
                           transition: max-height 0.5s ease-in;
                        }
                        & > .price-information-list-item:last-child {
                           margin-bottom: 8px;
                        }
                     }
                  }
               }
            }
         }
         @media (max-width: 767.98px) {
            .price-information-table-inner {
               border: none;

               .price-information-table-header {
                  display: none;
               }

               .price-information-table-content {
                  .price-information-room-item {
                     display: block;
                     padding: 0;
                     margin-bottom: 24px;
                     border: none;

                     &:last-child {
                        margin-bottom: 0;
                     }

                     .table-content-fixed-item {
                        width: 100%;
                        max-width: 100%;
                        margin-right: 0;
                        margin-bottom: 0;
                        padding: 16px;
                        background-color: var(--gray-100);
                        border: 1px solid var(--gray-300);
                        border-radius: 10px 10px 0 0;
                        border-bottom: none;

                        &:last-child {
                           width: 100%;
                           max-width: 100%;
                           margin-top: 0;
                           margin-bottom: 0;
                           background-color: var(--gray-100);
                           border: 1px solid var(--gray-300);
                           border-radius: 0 0 10px 10px;
                           border-top: none;
                           justify-content: center;
                           padding: 12px;
                        }

                        & > span {
                           font-size: 16px;
                        }
                     }

                     .table-content-list {
                        width: 100%;

                        .price-information-list.default-list {
                           .price-information-list-item {
                              display: block;
                              border: 1px solid var(--gray-300);
                              border-top: none;
                              border-radius: 0;
                              margin-bottom: 0;
                              padding: 0;

                              &:last-child {
                                 border-radius: 0 0 10px 10px;
                              }

                              & > span {
                                 display: grid;
                                 grid-template-columns: 50% 50%;
                                 padding: 12px 16px;
                                 border-bottom: 1px solid var(--gray-300);
                                 text-align: left;

                                 &:last-child {
                                    border-bottom: none;
                                 }

                                 &::before {
                                    content: attr(data-label);
                                    font-weight: 700;
                                    font-size: 14px;
                                    color: var(--gray-700);
                                    display: block;
                                    margin-bottom: 4px;
                                 }
                              }
                           }

                           .price-information-detail-list {
                              .price-information-list-item {
                                 border-radius: 0;

                                 &:last-child {
                                    border-radius: 0;
                                 }
                              }
                           }

                           & > .price-information-list-item.first-item {
                              border-radius: 0;
                           }

                           & > .price-information-list-item.last-item {
                              border-radius: 0;
                           }
                        }
                     }
                  }
               }
            }
         }
      }
   }
}
</style>
